import React, { useEffect, useState } from 'react';
import { Modal, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import JEEE_results from '../assets/videos/kbs-reel.mp4'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  maxWidth: '90vw',      // Responsive width
  maxHeight: '90vh',      // Responsive height
  aspectRatio: '9 / 16',      // 9:16 ratio
  bgcolor: '#000',   // Black for video background
  boxShadow: 24,
  borderRadius: 4,
  outline: 'none',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  '@media (max-width: 600px)': {
    aspectRatio: 'auto',
    height: '80vh', // reduced height on mobile
    width: '90vw',
  }
};

const ModalVideoC = () => {
  const [open, setOpen] = useState(true);

  // useEffect(() => {
  //   const hasShown = localStorage.getItem('hasShownModalVideo');
  //   if (!hasShown) {
  //     setOpen(true);
  //     localStorage.setItem('hasShownModalVideo', 'true');
  //   }
  // }, []);

  const handleClose = () => setOpen(false);

  return (
    <Modal open={open} >
      <Box sx={style}>
        {/* Close Button */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 2,
            width: '100%',
            px: 2,
            py: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'rgba(0,0,0,0.4)',
          }}
        >
          <Typography sx={{ color: '#fff', fontSize: 14 }}>
            Latest JEE Result
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>


        {/* Video */}
        <Box sx={{ flex: 1, backgroundColor: 'black' }}>
      
            <video
            src={JEEE_results}
            autoPlay
            muted
            defaultMuted
            playsInline
            loop
            style={{ border: 'none',display:'block' }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalVideoC;
